import { Component, Input, OnChanges, OnDestroy, SimpleChanges } from "@angular/core";

@Component({
  selector: "app-live-pros-banner",
  templateUrl: "./live-pros-banner.component.html",
  styleUrls: ["./live-pros-banner.component.scss"],
})
export class LiveProsBannerComponent implements OnChanges, OnDestroy {
  @Input() onlineProsCount: number | null = null;
  animatedCount = 0;
  private animationTimer: any = null;

  get isLoading(): boolean {
    return this.onlineProsCount === null;
  }

  get displayCount(): number {
    if (typeof this.onlineProsCount === "number") {
      return this.onlineProsCount;
    }
    return 0;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes["onlineProsCount"] ||
      this.animatedCount === 0
    ) {
      this.animateTo(this.displayCount);
    }
  }

  ngOnDestroy(): void {
    this.clearAnimation();
  }

  private clearAnimation() {
    if (this.animationTimer) {
      clearInterval(this.animationTimer);
      this.animationTimer = null;
    }
  }

  private animateTo(target: number) {
    const safeTarget = Math.max(0, Math.floor(target || 0));
    const start = Math.max(0, Math.floor(this.animatedCount || 0));

    if (start === safeTarget) {
      this.animatedCount = safeTarget;
      return;
    }

    this.clearAnimation();

    const steps = 24;
    const durationMs = 700;
    const intervalMs = Math.max(16, Math.floor(durationMs / steps));
    let currentStep = 0;

    this.animationTimer = setInterval(() => {
      currentStep += 1;
      const progress = currentStep / steps;
      const easedProgress = 1 - Math.pow(1 - progress, 3);
      this.animatedCount = Math.round(start + (safeTarget - start) * easedProgress);

      if (currentStep >= steps) {
        this.animatedCount = safeTarget;
        this.clearAnimation();
      }
    }, intervalMs);
  }
}
